import React, { Component } from 'react';
import styled from 'styled-components';

import { Font, FontWeight } from '../../../utils/fonts';
import mediaWidth from '../../../utils/mediaWidth/mediaWidth';

import sircle from './assets/sircle.svg';

class SuccessMessage extends Component {
    render() {
        const { className } = this.props;

        return (
            <Root className={className}>
                <ImageBlock>
                    <Img src={sircle} />
                </ImageBlock>
                <WrapperFlex>
                    <Headline>
                        Спасибо!
                        <br />
                        Ваша заявка принята
                    </Headline>
                    <Message>
                        Мы свяжемся с вами
                        <Br740 />
                        {' '}
                        в течение двух дней
                    </Message>
                </WrapperFlex>
            </Root>
        );
    }
}

const Root = styled.div`
    background: inherit;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    text-align: center;
 
    ${mediaWidth.m} {
        text-align: left;
    }
`;

const ImageBlock = styled.div`
    width: 114px;
    height: 114px;

    margin: 0 auto;
    margin-bottom: 40px;

    ${mediaWidth.m} {
        margin: initial;
        margin-bottom: 48px;
    }

    ${mediaWidth.l} {
        width: 151px;
        height: 151px;
    }

    ${mediaWidth.xl} {
        margin-bottom: 44px;        
    }
`;

const Img = styled.img`
    display: block;

    width: 114px;
    height: 114px;

    ${mediaWidth.l} {
        width: 151px;
        height: 151px;
    }
`;

const WrapperFlex = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    ${mediaWidth.m} {
        justify-content: flex-start;
        align-items: flex-start; 
    }
`;

const Headline = styled.div`
    ${Font.HEADLINE};
    ${FontWeight.REGULAR};
    font-size: 16px;
    line-height: 19px;

    text-transform: uppercase;

    color: #0032A0;

    margin-bottom: 16px;

    ${mediaWidth.m} {
        font-size: 20px;
        line-height: 23px;

        margin-bottom: 40px;
    }

    ${mediaWidth.xl} {
        font-size: 24px;
        line-height: 28px;

        margin-bottom: 34px;
    }
`;

const Message = styled.div`
    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
    font-size: 16px;
    line-height: 24px;

    color: rgba(0, 0, 0, 0.64);

    ${mediaWidth.m} {
        font-size: 20px;
        line-height: 28px;
    }

    ${mediaWidth.xl} {
        font-size: 24px;
        line-height: 32px;
    }
`;

const Br740 = styled.br`
    display: none;

    ${mediaWidth.m} {
        display: block;
    }
`;

export default SuccessMessage;
